import script from "./PersonalShopperCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalShopperCard.vue?vue&type=script&setup=true&lang=js"

import "./PersonalShopperCard.vue?vue&type=style&index=0&id=36e4c69f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e4c69f"]])

export default __exports__